var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImplantableHardware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.793,
    height: 78.099,
    viewBox: "0 0 39.793 78.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Implantable_Hardware",
    "data-name": "Implantable Hardware",
    transform: "translate(-91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15956",
    "data-name": "Path 15956",
    d: "M199.088,166v45.761c0,3.8-2.424,7.017-5.426,7.017h-7.235c-3,0-5.426-3.218-5.426-7.017V166Z",
    transform: "translate(-79.147 -140.679)",
    fill: "#4c36e4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10863",
    "data-name": "Group 10863",
    transform: "translate(98.235 36.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15958",
    "data-name": "Path 15958",
    d: "M176.323,243.288a2.07,2.07,0,0,1-1.809,2.288H152.809a2.352,2.352,0,0,1,0-4.576h21.705A2.07,2.07,0,0,1,176.323,243.288Z",
    transform: "translate(-151 -241)",
    fill: "#99baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15959",
    "data-name": "Path 15959",
    d: "M176.323,303.288a2.07,2.07,0,0,1-1.809,2.288H152.809a2.352,2.352,0,0,1,0-4.576h21.705A2.07,2.07,0,0,1,176.323,303.288Z",
    transform: "translate(-151 -291.848)",
    fill: "#99baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15960",
    "data-name": "Path 15960",
    d: "M176.323,363.288a2.07,2.07,0,0,1-1.809,2.288H152.809a2.352,2.352,0,0,1,0-4.576h21.705A2.07,2.07,0,0,1,176.323,363.288Z",
    transform: "translate(-151 -342.695)",
    fill: "#99baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15961",
    "data-name": "Path 15961",
    d: "M176.323,423.288a2.07,2.07,0,0,1-1.809,2.288H152.809a2.352,2.352,0,0,1,0-4.576h21.705A2.07,2.07,0,0,1,176.323,423.288Z",
    transform: "translate(-151 -393.543)",
    fill: "#99baff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15966",
    "data-name": "Path 15966",
    d: "M176.323,106v9.152a2.07,2.07,0,0,1-1.809,2.288H152.809A2.07,2.07,0,0,1,151,115.152V106Z",
    transform: "translate(-52.765 -89.831)",
    fill: "#98baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15968",
    "data-name": "Path 15968",
    d: "M128.984,0h-7.235a1.552,1.552,0,0,0-1.266.687c-2.134,2.7-5.86,4.072-9.587,4.072S103.444,3.386,101.31.686A1.552,1.552,0,0,0,100.044,0H92.809A2.07,2.07,0,0,0,91,2.288V16.169a2.07,2.07,0,0,0,1.809,2.288h36.175a2.07,2.07,0,0,0,1.809-2.288V2.288A2.07,2.07,0,0,0,128.984,0Z",
    transform: "translate(0 0)",
    fill: "#4c36e4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImplantableHardware);
export default __webpack_public_path__ + "static/media/ImplantableHardware.ed4c68033debb120b50f6c7b6c929845.svg";
export { ForwardRef as ReactComponent };